import { format } from "date-fns";
import Icon1 from "../../icons/Icon";
import { fr, is } from "date-fns/locale"; // Importing the French locale
import SmallSpinner from "../../loading/SmallSpinner";
import { flutterColorToHex } from "../../config/theme";
import { isColorTooDark } from "../../models/OrgFunctions";

export const PlanningRDVHeader = ({
  handleSetDayView,

  show_weekend,
  setShowWeekend,
  simplified_view,
  setSimplifiedView,
  appState,
  setAppState,
  planning_config,
  modal_open,
  day_view,
  currentWeekStart,
  previousWeek,
  nextWeek,
  currentWeek,
  weekDates,
  orgData,
  getWeekNumber,
  daysOfWeek,
  workspaceData,
}) => {
  return (
    <>
      <div
        className="select-none flex flex-col sticky top-0 bg-white min-h-fit"
        style={{ zIndex: modal_open ? 1 : 8 }}
      >
        <div className=" flex flex-col  gap-1  rounded-md w-full p-1 ">
          <div className="   rounded-md flex flex-row w-full gap-4 ">
            <div className="flex  flex-row gap-1  w-fit ">
              <div
                onClick={previousWeek}
                className="flex flex-row bg-cyan-200 w-8 h-8 items-center  rounded-md justify-center shadow-md  cursor-pointer hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-blue-300"
              >
                <Icon1 icon_name="left" fill="blue" size={17}></Icon1>
              </div>{" "}
              <div className="flex min-w-fit select-none  flex-row bg-white border-neutral-200 border-1 w-fit  px-4 h-8 text-shadow_50 text-h3  items-center  rounded-md justify-center shadow-md ">
                Semaine {getWeekNumber(currentWeekStart)}
              </div>
              <div
                onClick={currentWeek}
                className="flex select-none flex-row bg-white w-36 h-8 text-shadow_50 text-h3  items-center cursor-pointer rounded-md justify-center shadow-md hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-blue-300"
              >
                Semaine actuelle
              </div>
              <div
                onClick={nextWeek}
                className="flex flex-row bg-cyan-200 w-8 h-8 items-center rounded-md justify-center  shadow-md cursor-pointer hover:shadow-lg border-1 border-neutral-200 hover:bg-slate-50 hover:border-blue-300"
              >
                <Icon1 icon_name="right" fill="blue" size={17}></Icon1>
              </div>
            </div>

            <div className="flex flex-row gap-2 justify-end flex-grow min-w-fit  ">
              <div
                onClick={(e) => {
                  setSimplifiedView(!simplified_view);
                  let new_planning_config = { ...planning_config };
                  new_planning_config.simplified_view = !simplified_view;
                  setAppState({
                    ...appState,
                    planning_config: new_planning_config,
                  });
                }}
                className={`
                        ${
                          simplified_view
                            ? "shadow-md bg-white text-shadow_50"
                            : "shadow-inner bg-neutral-100 text-shadow_25"
                        }
                        flex  select-none   border-neutral-300 border-1  hover:shadow-md cursor-pointer  flex-row  px-4 w-fit h-8  text-h3  items-center  rounded-md justify-center `}
              >
                Condensé
              </div>
              <div
                onClick={(e) => {
                  setShowWeekend(!show_weekend);
                  let new_planning_config = { ...planning_config };
                  new_planning_config.show_weekend = !show_weekend;
                  setAppState({
                    ...appState,
                    planning_config: new_planning_config,
                  });
                }}
                className={`
                        ${
                          show_weekend
                            ? "shadow-md bg-white text-shadow_50"
                            : "shadow-inner bg-neutral-100 text-shadow_25"
                        }
                        flex  select-none   border-neutral-300 border-1  hover:shadow-md cursor-pointer  flex-row  px-4 w-fit h-8  text-h3  items-center  rounded-md justify-center `}
              >
                Weekend
              </div>
            </div>
          </div>
        </div>
        <div className="flex bg-transparent flex-row  flex-grow min-h-fit ml-10 gap-1 p-1">
          {day_view == null &&
            daysOfWeek.map((day, index) => (
              <div
                key={day + index.toString()}
                className={`bg-transparent flex flex-col  w-1/5  font-light min-h-fit  text-h4 text-black justify-center`}
              >
                <div
                  className={` flex flex-col select-none w-full  border-gray-200  border-1 py-0.5  text-h4  items-center  rounded-md justify-center shadow-md  ${
                    //if this date is today, setbg-blue-100
                    weekDates[index].getDate() === new Date().getDate() &&
                    weekDates[index].getMonth() === new Date().getMonth() &&
                    weekDates[index].getFullYear() === new Date().getFullYear()
                      ? "border-b-2 border-b-blue-400 text-blue-400"
                      : "text-shadow_50"
                  }`}
                >
                  <div className=" w-full   h-full flex justify-center">
                    {day}
                  </div>
                  <div
                    className={` text-h4 w-full h-full flex justify-center 
                     
                      `}
                  >
                    {/* Format the Date object to "d MMMM" (e.g., "15 Septembre") */}
                    {format(weekDates[index], "d MMMM" + " ", {
                      locale: fr,
                    })}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};
